var map = {
	"./0iconmonstr-paintbrush-7.svg": 8520,
	"./1blueLiv.png": 9214,
	"./2redLiv.png": 5869,
	"./3greenLiv.png": 8858,
	"./4goldLiv.png": 1832,
	"./5grayLiv.png": 4574
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6864;